const afgcPublicationClass = {
  /**
   * @var $root jQuery
   */
  $root: null,
  config: {
    'ajaxurl': '',
    'currentDir': '/',
    'groupId': 0,
    'action': '',
    'nonce': '',
  },
  init() {
    if ("afgcPublication" in window) {
      this.config = window.afgcPublication;
    }
    this.$root = jQuery('main');
    this.initResumes();
    this.initTab();
    this.initDownload();
  },
  initResumes() {
    this.$root.find(".pdf").each((index, element) => {
      const $element = jQuery(element).find('.pdf-content');
      const url = $element.attr('data-src');
      const pdfLib = window['pdfjs-dist/build/pdf'];
      // noinspection JSUnresolvedVariable
      pdfLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
      let pdfDoc = null,
        pageNum = 1,
        pageRendering = false,
        pageNumPending = null,
        scale = 1,
        canvas = $element.get(0),
        ctx = canvas.getContext('2d');

      function renderPage(num) {
        pageRendering = true;
        // noinspection JSUnresolvedFunction
        pdfDoc.getPage(num).then(function (page) {
          const viewport = page.getViewport({scale: scale});
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          const renderContext = {
            canvasContext: ctx,
            viewport: viewport
          };
          const renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            pageRendering = false;
            if (pageNumPending !== null) {
              renderPage(pageNumPending);
              pageNumPending = null;
            }
          });
        });
        jQuery(element).find('.page_num').text(num);
      }

      function queueRenderPage(num) {
        if (pageRendering) {
          pageNumPending = num;
        } else {
          renderPage(num);
        }
      }

      function onPrevPage() {
        if (pageNum <= 1) {
          return;
        }
        pageNum--;
        queueRenderPage(pageNum);
      }

      jQuery(element).find(".previous").on('click', onPrevPage);

      function onNextPage() {
        if (pageNum >= pdfDoc.numPages) {
          return;
        }
        pageNum++;
        queueRenderPage(pageNum);
      }

      jQuery(element).find(".next").on('click', onNextPage);

      pdfLib.getDocument(url).promise.then(function (pdfDoc_) {
        pdfDoc = pdfDoc_;
        jQuery(element).find('.page_max').text(pdfDoc.numPages);
        if (pdfDoc.numPages <= 1) {
          jQuery(element).find('.pdf-pagination').hide();
        }
        renderPage(pageNum);
      });
    });
  },
  initTab: function () {
    const $menuItems = this.$root.find('.publication-topMenu .afgc-container .publication-menu-item a[href^="#"]');
    const $items = this.$root.find('.publication-item');
    $menuItems.on('click', (event) => {
      event.stopPropagation();
      const $menuItem = jQuery(event.currentTarget);
      $menuItems.parent().removeClass('is-active');
      $menuItem.parent().addClass('is-active');
      $items.removeClass('show');
      const currentTab = $menuItem.attr('href').replace('#', '');
      let $currentTab = $items.filter('[data-target=' + currentTab + ']');
      if (!$currentTab.length) {
        $currentTab = $items.filter('[data-target=home]');
      }
      $currentTab.addClass('show');
    });

    const location = document.location.toString();
    let found = false;
    $menuItems.each((index, element) => {
      const $element = jQuery(element);
      if (location.match(new RegExp($element.attr('href'), 'i'))) {
        $element.trigger('click');
        found = true;
        return false;
      }
    });
    if (!found) {
      $menuItems.first().trigger('click');
    }
  },
  initDownload: function () {
    const $btnBuy = this.$root.find('.btn-buy');
    $btnBuy.on('click', (e) => {
      e.stopPropagation();
      this.modalLink()
    });
    //
    // $('#modal-alert-message').text('L\'inscription s\'est terminée avec succès, vous allez être redirigé vers les informations de paiement');
    // $('#modal-alert').modal('show');
    // window.location = data.redirect_to;
  },
  modalLink: function (data = {}) {
    const $btnBuy = this.$root.find('.btn-buy');
    const $modalPayment = jQuery('#modal-payment');
    const $modalPaymentBody = $modalPayment.find('.modal-body');
    const $modalPaymentLinks = $modalPayment.find('.modal-footer');
    $modalPaymentBody.html('Chargement en cours...');
    $modalPaymentLinks.find('> a, > button').not('[data-dismiss]').remove();
    jQuery.ajax({
      cache: false,
      method: 'POST',
      dataType: 'json',
      url: $btnBuy.data('ajax'),
      data: Object.assign({
        nonce: $btnBuy.data('nonce'),
        publication: $btnBuy.data('publication')
      }, data),
      success: (data) => {
        if(data.error) {
          $modalPaymentBody.html(data.error);
          return;
        }
        $modalPaymentBody.html(data.message);
        if ("links" in data) {
          data.links.forEach((item) => {
            const $link = jQuery("href" in item ? '<a/>' : '<button/>', {
              text: item.title,
              title: item.title,
              type: "button",
              class: "btn btn-small btn-primary"
            });
            if ("href" in item) {
              $link.attr('href', item.href);
            } else if ("ajax" in item) {
              $link.on('click', (e) => {
                e.stopPropagation();
                this.modalLink(item.ajax);
              });
            }
            if ("target" in item) {
              $link.attr('target', item.target);
            }
            $link.appendTo($modalPaymentLinks);
          });
        }
        //window.initPayment();
        /*$modalPayment.on('hide.bs.modal', function () {
          window.location.href = '/mon-compte/commandes/';
        });*/
      },
      error: (jqXHR, textStatus) => {
        console.log('data error', jqXHR, textStatus);
      }
    });
    $modalPayment.modal('show');
  },
};

// noinspection JSUnresolvedVariable
(function () {
  afgcPublicationClass.init();
  // window.t = afgcPublicationClass;
})();

